import React, {Component} from "react";
import FlexView from "react-flexview";
import {Tab, TabList, TabPanel, Tabs} from "react-tabs";
import DailyMonitoring from "./components/dailyMonitoring";
import CashFlowMonitoring from "./components/cashFlowMonitoring";
import Api from "../../../../Services/Api";
import {mapToObjectDDL} from "../../../common/mapper";
import Container from "../../../../modules/commons/Container";
import SimpleDDL from "../../../../modules/SimpleDDL";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import ErrorAction from "../../../../Redux/ErrorRedux";
import {connect} from "react-redux";
import SimpleLoadingOverlay from "../../../../modules/popup/SimpleLoadingOverlay";
import {fetchDataAsync} from "../../../../Services/Utils";

class DashboardCashier extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            dataCabang: [],
            kodeCabang: {},
            selectedCabang: null,
        };
    }

    async componentDidMount() {
        await this.fetchDataCabang();
    }

    handleTriggerLoading = () => {
        this.setState((prevValue) => ({...prevValue, loading: !prevValue.loading}));
    };

    fetchDataCabang = async () => {
        this.handleTriggerLoading();
        try {
            let res = await fetchDataAsync({
                asyncFn: Api.create("NAGAMAS_MASTER_DATA").findAllMasterCabang,
                setError: this.props.setError,
                menuName: "Dashboard Cashier - Monitoring Transaksi Kas Harian",
            });
            if (res.ok) {
                let filteredData = res.data.data.filter(
                    item => this.props.menuAccess.map(data => data.idRefObj).includes(item.kodeCabang)
                );

                if (filteredData.length !== 0) {
                    this.setState((prevValue) => ({
                        ...prevValue,
                        dataCabang: filteredData,
                        kodeCabang: mapToObjectDDL(filteredData[0].namaDealer, filteredData[0].kodeCabang),
                    }))
                }
            }
        } catch (e) {
            console.log("errors", e);
        }
        this.handleTriggerLoading();
    };

    handleChangeKodeCabang = (value) => {
        this.setState((prevValue) => ({
            ...prevValue,
            kodeCabang: value,
        }))
    };

    handleCari = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            selectedCabang: this.state.kodeCabang?.value || null,
        }));
    };

    render() {
        return (
            <>
                <Container>
                    <FlexView>
                        <SimpleDDL
                            id="select_options_kode_cabang"
                            box="search"
                            name="kodeCabang"
                            isClearable
                            placeholder="Nama Cabang"
                            containerclassname="width width-250px"
                            options={
                                this.state.dataCabang.map(
                                    item => mapToObjectDDL(item.namaDealer, item.kodeCabang)
                                )
                            }
                            value={this.state.kodeCabang}
                            onChange={(value) => this.handleChangeKodeCabang(value)}
                        />
                        <SimpleButton styles={{marginTop: "5px"}} onClick={this.handleCari}>Cari</SimpleButton>
                    </FlexView>
                    <Tabs>
                        <TabList>
                            <Tab>Monitoring Transaksi Kas Harian</Tab>
                            <Tab>Monitoring Transaksi Bank Harian</Tab>
                            <Tab>Monitoring BKM</Tab>
                            <Tab>Monitoring BKK</Tab>
                            <Tab>Monitoring BBM</Tab>
                            <Tab>Monitoring BBK</Tab>
                        </TabList>
                        <TabPanel>
                            <DailyMonitoring
                                {...this.props}
                                tab="cash"
                                kodeCabang={this.state.selectedCabang}
                                triggerLoading={this.handleTriggerLoading}
                            />
                        </TabPanel>
                        <TabPanel>
                            <DailyMonitoring
                                {...this.props}
                                tab="bank"
                                kodeCabang={this.state.selectedCabang}
                                triggerLoading={this.handleTriggerLoading}
                            />
                        </TabPanel>
                        <TabPanel>
                            <CashFlowMonitoring
                                {...this.props}
                                tab="bkm"
                                kodeCabang={this.state.selectedCabang}
                                triggerLoading={this.handleTriggerLoading}
                            />
                        </TabPanel>
                        <TabPanel>
                            <CashFlowMonitoring
                                {...this.props}
                                tab="bkk"
                                kodeCabang={this.state.selectedCabang}
                                triggerLoading={this.handleTriggerLoading}
                            />
                        </TabPanel>
                        <TabPanel>
                            <CashFlowMonitoring
                                {...this.props}
                                tab="bbm"
                                kodeCabang={this.state.selectedCabang}
                                triggerLoading={this.handleTriggerLoading}
                            />
                        </TabPanel>
                        <TabPanel>
                            <CashFlowMonitoring
                                {...this.props}
                                tab="bbk"
                                kodeCabang={this.state.selectedCabang}
                                triggerLoading={this.handleTriggerLoading}
                            />
                        </TabPanel>
                    </Tabs>
                </Container>
                {this.state.loading && <SimpleLoadingOverlay active={this.state.loading}/>}
            </>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        setError: (payload) => dispatch(ErrorAction.setError(payload)),
    };
};

export default connect(null, mapDispatchToProps)(DashboardCashier);